import { BASE_URL, request } from "./api";
import type { Fee } from "./types";

// GET /api/Fees
export const getFees = (): Promise<Fee[]> => {
  return request<Fee[]>(`${BASE_URL}/api/Fees`, { method: "GET" });
};

// GET /api/Fees/{id}
export const getFeeById = (id: number): Promise<Fee> => {
  return request<Fee>(`${BASE_URL}/api/Fees/${id}`, { method: "GET" });
};

// POST /api/Fees
export const createFee = (data: { feeName: string }): Promise<Fee> => {
  return request<Fee>(`${BASE_URL}/api/Fees`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data,
  });
};
